import { Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import {
  NotificationProvider,
  PrivateRoute,
  TentangKami,
  Kontak,
  Profile,
  Login,
  Actions,
  Sukses,
  SyaratKetentuan,
  KebijakanPrivasi,
  SuratPernyataan,
  FormPendaftaran,
  MyOrders,
  EntryList,
  CheckYourName,
  Xtrifeinnie,
  OrderDetail,
  MidtransScript,
  JMM,
  SMM,
  BMM,
  Regulations,
  VoucherManagement,
  Participants,
  ParticipantsEdit,
  Results,
  ResultsDetail,
  ResultsJMMLive,
} from "@mmfestival/shared-components";

import { Layout } from "./components/Layout";
import Beranda from "./Beranda";

// Admin Imports
import { AdminRoute } from "./common/AdminRoute";
import { AdminLayout } from "./layout/AdminLayout";
import { Dashboard } from "./pages/admin/Dashboard";
import { Participants as AdminParticipants } from "./pages/admin/Participants";
import { AdminVolunteer as Volunteers } from "./pages/admin/Volunteers";
import { RaceResultsUpload } from "./pages/admin/RaceResultsUpload";
import { Vouchers } from "./pages/admin/Vouchers";
import RacePackCollection from "./pages/admin/RacePackCollection";
import SMMRacepack from "./pages/admin/SMMRacepack";
import { BroadcastEmail } from "./pages/admin/BroadcastEmail";
import { RPCS } from "@mmfestival/shared-components";

const NotFound = () => (
  <section className="w-full min-h-screen py-20 text-center text-slate-700 flex-col justify-center relative bg-white flex">
    <h2 className="text-xl sm:text-2xl md:text-3xl font-normal uppercase mb-2 text-slate-700 tracking-widest">
      PAGE
    </h2>
    <p className="text-4xl sm:text-5xl md:text-7xl font-black mx-auto mb-10 text-slate-700 px-4">
      NOT FOUND
    </p>

    <p className="text-lg text-slate-500 mb-10 px-6">
      The page you are looking for doesn’t exist or has been moved.
    </p>
  </section>
);

/* (Optional) Loading Fallback */
const LoadingFallback = () => (
  <div className="w-full min-h-screen flex items-center justify-center bg-white">
    <div className="text-center text-slate-700">
      <p className="text-xl font-semibold">Loading...</p>
    </div>
  </div>
);

const App = () => {
  const { pathname } = useLocation();
  const shouldLoadMidtrans = [
    "/form",
    "/myorders",
    "/order-detail",
    "/jmm",
    "/smm",
    "/bmm",
  ].some((path) => pathname.toLowerCase().startsWith(path));

  return (
    <AuthProvider>
      <NotificationProvider>
        {shouldLoadMidtrans && <MidtransScript />}

        <Routes>
          <Route path="/" element={<Layout />}>
            {/* Main Routes */}
            <Route index element={<Beranda />} />

            <Route path="Tentangkami" element={<TentangKami />} />
            <Route path="Kontak" element={<Kontak />} />
            <Route path="SyaratKetentuan" element={<SyaratKetentuan />} />
            <Route path="KebijakanPrivasi" element={<KebijakanPrivasi />} />
            <Route path="Regulations" element={<Regulations />} />
            <Route path="VoucherManagement" element={<VoucherManagement />} />
            <Route path="Participants" element={<Participants />} />
            <Route path="participants/edit" element={<ParticipantsEdit />} />
            <Route path="ParticipantsEdit" element={<ParticipantsEdit />} />
            <Route
              path="entrylist/:eventId/:category"
              element={<EntryList />}
            />
            <Route path="entrylist/:eventId" element={<EntryList />} />
            <Route path="checkyourname" element={<CheckYourName />} />

            {/* Auth Routes */}
            <Route path="Login" element={<Login />} />

            {/* User Protected Routes */}
            <Route
              path="Profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />

            <Route path="MyOrders" element={<MyOrders />} />
            <Route path="/order-detail" element={<OrderDetail />} />
            <Route path="form/:slug" element={<FormPendaftaran />} />

            {/* Event Pages */}
            <Route path="JMM" element={<JMM />} />
            <Route path="SMM" element={<SMM />} />
            <Route path="BMM" element={<BMM />} />
            <Route path="results" element={<Results />} />
            <Route path="results/JMM" element={<ResultsJMMLive />} />
            <Route path="results/:eventId" element={<Results />} />
            <Route
              path="results/:eventId/:category/:name"
              element={<ResultsDetail />}
            />

            <Route path="Sukses" element={<Sukses />} />

            <Route
              path="SuratPernyataan/:eventId"
              element={<SuratPernyataan />}
            />

            {/* SMM Racepack Collection (single-event RPC) */}
            <Route path="/smm" element={<AdminRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="rpc" element={<SMMRacepack />} />
              </Route>
            </Route>

            {/* Admin Routes */}
            <Route path="/admin" element={<AdminRoute />}>
              <Route element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="participants" element={<AdminParticipants />} />
                <Route path="volunteers" element={<Volunteers />} />
                <Route path="race-results" element={<RaceResultsUpload />} />
                <Route path="vouchers" element={<Vouchers />} />
                <Route path="broadcast-email" element={<BroadcastEmail />} />
                <Route path="rpc" element={<RacePackCollection />} />
              </Route>
            </Route>

            {/* Special Routes */}
            <Route
              path="Xtrifeinnie"
              element={
                <PrivateRoute>
                  <Xtrifeinnie />
                </PrivateRoute>
              }
            />

            <Route path="Actions" element={<Actions />} />
            <Route path="rpcs" element={<RPCS />} />

            {/* 404 PAGE */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;
